import React, { useState, Fragment } from "react"
import Lightbox from "react-image-lightbox"
import "react-image-lightbox/style.css"

import pcs from "../../images/photos-coming-soon.jpg"

import "./index.scss"

const fileBucket = process.env.FILE_BUCKET

const ImageGallery = ({ images, dealership }) => {
  const [imageIndex, setImageIndex] = useState(0)
  const [isOpen, setIsOpen] = useState(false)

  const imagePath = `${fileBucket}/images/${dealership}`

  if (images) {
    const listImages = images.map((image, index) => {
      const imageSplit = image.filename.split(".")
      const basename = imageSplit[0].replace(/ /g, "%20")
      const extension = imageSplit[1]
      return (
        <Fragment key={image.id}>
          {index < 1 ? (
            <div className="col-12 gallery-image-main-container">
              <img
                src={`${imagePath}/${basename}_750.${extension}`}
                className="gallery-image-main"
                alt=""
                onClick={() => {
                  setIsOpen(true)
                  setImageIndex(index)
                }}
                srcSet={`
        ${imagePath}/${basename}_1000.${extension} 1000w,
        ${imagePath}/${basename}_750.${extension} 750w,
        ${imagePath}/${basename}_500.${extension} 500w,
        ${imagePath}/${basename}_300.${extension} 300w
        `}
                sizes="
        (min-width: 768px) 50vw,
        100vw
        "
                role="presentation"
              />
            </div>
          ) : (
            <div className="col-3 col-md-4 col-lg-3 col-xl-2 text-center gallery-image-thumbnail-container">
              <img
                src={`${imagePath}/${basename}_300.${extension}`}
                className="gallery-image-thumbnail"
                alt=""
                onClick={() => {
                  setIsOpen(true)
                  setImageIndex(index)
                }}
                role="presentation"
              />
            </div>
          )}
        </Fragment>
      )
    })

    const makeFilePath = (filename) => {
      const imageSplit = filename.split(".")
      const basename = imageSplit[0].replace(/ /g, "%20")
      const extension = imageSplit[1]
      return `${imagePath}/${basename}_2500.${extension}`
    }

    return (
      <div className="row">
        {listImages}
        {isOpen && (
          <Lightbox
            mainSrc={makeFilePath(images[imageIndex].filename)}
            nextSrc={makeFilePath(
              images[(imageIndex + 1) % images.length].filename
            )}
            prevSrc={makeFilePath(
              images[(imageIndex + images.length - 1) % images.length].filename
            )}
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={() =>
              setImageIndex((imageIndex + images.length - 1) % images.length)
            }
            onMoveNextRequest={() =>
              setImageIndex((imageIndex + 1) % images.length)
            }
          />
        )}
      </div>
    )
  } else {
    return (
      <div className="row">
        <div className="col-12 gallery-image-main-container">
          <img
            src={pcs}
            className="gallery-image-main"
            alt="Photos Coming Soon"
          />
        </div>
      </div>
    )
  }
}

export default ImageGallery
